module.exports = __webpack_public_path__ + "img/link.bd13dcec.svg";